import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PaginationContainer from '../Containers/PaginationContainer';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import TableList from '../Table/TableList';
import Tooltip from '@material-ui/core/Tooltip';
import Permissions from '../../services/Permissions';
import Loading from '../DisplayOriented/Loading';
import SimpleModalWrapped from '../Containers/SimpleModalWrapped';
import { SnackbarContext } from '../../services/ContextProviders/Snackbar';
import Company from '../../services/DataModels/Company';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Typography from '@material-ui/core/Typography';

//icons
import MemoryIcon from '@material-ui/icons/Memory';
import AddIcon from '@material-ui/icons/Add';
import AccountCircleIcon from '@material-ui/icons/AccountCircleOutlined';
import LanguageIcon from '@material-ui/icons/Language';
import PersonIcon from '@material-ui/icons/Person';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';


const heading_info = [
    { label: "Name", value: "table_name", field: "name", align: "left", disablePadding: false, sortable: true, content: "function" },
    { label: "Website", field: "website", align: "left", disablePadding: false, sortable: true },
    { label: "Parent Account", value: "nested_company.name", field: "company_id", nested_field: "true", align: "left", disablePadding: false, sortable: true },
];

const styles = theme => ({
    container: {
        fontFamily: "Inter",
        flexGrow: 2,
        width: "75%"
    },
    integrationsContainer: {
        overflowY: "auto",
        padding: "12px",
        height: "calc(100% - 82px)",
        alignItems: "flex-start",
        display: "flex",
        flexWrap: "wrap",
        backgroundColor: "#f5f5f7",
    },
    cardItemsContainer: {
        overflowY: "auto",
        height: "calc(100% - 82px)",
        padding: "12px",
        alignItems: "flex-start",
        flexWrap: "wrap",
        backgroundColor: "#f5f5f7",
    },
    tableItemsContainer: {
        overflowY: "auto",
        height: "calc(100% - 82px)",
        alignItems: "flex-start",
        flexWrap: "wrap",
        backgroundColor: "#ffffff",
    },
    integrationCardContainer: {
        width: "33.33%",
        display: "inline-flex",
        justifyContent: "center",
    },
    noShow: {
        visibility: "hidden"
    },
    imageContainer: {
        display: "flex",
        height: "138px",
        cursor: "pointer",
        backgroundColor: "#f5f5f7",
    },
    image: {
        maxWidth: "100%",
        maxHeight: "138px",
        margin: "auto",
        display: "block",
    },
    textRowContainer: {
        position: "relative",
        padding: "16px 24px 24px 24px",
        cursor: "pointer",
    },
    companyContainer: {
        display: "flex",
        alignItems: "center",
        marginTop: "8px",
        width: "100%",
    },
    companyIcon: {
        fontSize: "20px",
        color: "#636366",
        marginRight: "8px",
    },
    companyLabel: {
        color: "#636366",
        overflow: "hidden",
        fontSize: "14px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    title: {
        fontSize: "16px",
        color: "#000000",
        opacity: "0.87",
        width: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        marginBottom: "16px",
    },
    iconWithTextContainer: {
        display: "flex",
        alignItems: "center",
        marginBottom: "8px",
        width: "100%",
    },
    iconLabel: {
        color: "#636366",
        overflow: "hidden",
        fontSize: "14px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    integrationCard: {
        boxShadow: "0px 3px 7px 2px #00000017",
        backgroundColor: "#fafafa",
        margin: "12px",
        width: "100%",
        minWidth: "250px",
        maxWidth: "380px",
        height: "auto",
        minHeight: "209px",
        border: "#ffffff solid 1px",
        transition: "border 250ms cubic-bezier(0.4, 0, 0.2, 2) 0ms",
        "&:hover": {
            border: `${theme.palette.pending.main} solid 1px`,
        },
    },
    linkText: {
        color: theme.primary,
        textDecoration: "underline",
        cursor: "pointer",
        marginLeft: "12px",
    },
    buttonContainer: {
        display: "flex",
        margin: "auto",
        marginRight: 0
    },
    viewDeviceButton: {
        padding: "8px",
    },
    placeholderProfileImage: {
        width: "60px",
        height: "60px",
        margin: "auto",
    },
    bottomRow: {
        display: "flex",
        backgroundColor: "white",
        padding: "8px",
    },
    actionListTitle: {
        marginBottom: "8px",
        padding: "11px 16px",
        borderBottom: "solid #80808073 1px",
        backgroundColor: "white",
        cursor: "unset",
        '&:hover': {
            backgroundColor: "white",
            cursor: "unset",
        },
        outline: "none",
        fontFamily: "Inter",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "1rem",
        width: "auto",
        height: "24px",
        whiteSpace: "nowrap",
        boxSizing: "content-box",
        fontWeight: 400,
        lineHeight: "1.5em",
    },
    actionMenuItem: {
        outline: "none",
    },
    optionsIconsContainer: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100%",
        height: "36px",
        backgroundColor: "#ffffff",
        padding: "8px",
        boxSizing: "border-box",
    },
    rightOptionsContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        width: "75%",
    },
    optionsIcon: {
        marginLeft: "16px",
        color: "#8e8e93",
        width: "20px",
        height: "20px",
        "& svg": {
            fontSize: "20px",
        },
        cursor: "pointer",
        "&:hover": {
            color: "#0263fc",
        },
        transition: "color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
    tip: {
        fontSize: "14px",
    },
    tipOverride: {
        padding: "8px",
        boxSizing: "border-box",
        marginTop: "0px",
    },
});

class AccountsList extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            layout: "card",
            menus: {},
            accounttodelete: null,
            modal: {
                open: false,
                children: () => ""
            },
        };
        this.set_menus();
    }

    set_menus = () => {
        if (!this.props.integrations) return;
        this.props.accounts.forEach((account) => {
            this.state.menus[account._id] = null;
        });
    }

    handleChangePage = (event, page) => {
        this.props.page_change({ page: page + 1, per_page: this.props.page_data.per_page });
    };

    handleChangeRowsPerPage = event => {
        this.props.page_change({ page: this.props.page_data.page, per_page: event.target.value });
    };

    open_account_tab = (account) => {
        this.props.tabHostProxy.addTab("account", account);
    }

    create_account = () => {
        this.props.tabHostProxy.addTab("account");
    }

    render_table_layout = () => {
        const { accounts, page_data } = this.props;
        if (!accounts) {
            return <Loading />;
        }
        return (
            <TableList
                headings={heading_info}
                items={accounts}
                page_data={page_data}
                perform_sort={this.props.perform_sort}
            />
        );
    }

    render_account_logo = (account) => {
        const { classes } = this.props;
        if (account.branding.logo_url !== "") {
            return (<img className={classes.image} src={account.branding.logo_url} />);
        } else {
            const defaultAccountImage = require('../../images/placeholder_users.svg').default;
            return (
                <img className={classes.placeholderProfileImage} src={defaultAccountImage} />
            );
        }
    }

    open_action_menu = (event, id) => {
        const element = event.target;
        this.setState((state) => {
            state.menus[id] = element;
            return state;
        });
    }

    close_action_menu = (id) => {
        this.setState((state) => {
            state.menus[id] = null;
            return state;
        });
    };

    render_menu = (account) => {
        const classes = this.props.classes;
        let anchorEl = this.state.menus[account._id];
        let open = Boolean(anchorEl);
        return (
            <div style={{ visibility: (this.get_actions(account).length === 0 ? "hidden" : "visible") }}>
                <div>
                    <IconButton
                        aria-label="More"
                        aria-owns={open ? 'long-menu' : undefined}
                        aria-haspopup="true"
                        onClick={(event) => this.open_action_menu(event, account._id)}
                        className={classes.menuIconButton}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </div>
                {this.render_action_menu(open, anchorEl, account)}
            </div>
        );
    }

    render_action_menu = (open, anchorEl, account) => {
        const classes = this.props.classes;
        return (
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => this.close_action_menu(account._id)}
                PaperProps={{
                    style: { overflow: "visible" }
                }}
            >
                <div className={classes.actionListTitle}>
                    Perform Action...
                </div>
                {this.get_actions().map((action, index) => (
                    <div onClick={() => { this.executeAction(action, account) }} key={action.label} className={classes.menuItemContainer}>
                        <MenuItem className={classes.actionMenuItem}>
                            <ListItemIcon>
                                {action.icon}
                            </ListItemIcon>
                            <Typography variant="inherit" noWrap>
                                {action.label}
                            </Typography>
                        </MenuItem>
                    </div>
                ))}
            </Menu>
        );
    }

    get_actions = () => {
        let possible_actions = [];
        possible_actions.push({ label: "View", action: "view", confirm: "Delete this account?", icon: <EditIcon /> });
        possible_actions.push({ label: "Delete", action: "delete", confirm: "Delete this account?", icon: <DeleteIcon /> });
        return possible_actions;
    }

    executeAction = (action, account) => {
        if (action.action === 'view') {
            this.close_action_menu(account._id);
            this.open_account_tab(account);
        } else if (action.action === 'delete') {
            this.state.accounttodelete = account;
            this.close_action_menu(account._id);
            this.openModal("Are you sure you want to delete this account?", "DELETE ACCOUNT", this.deleteAccount);
        }

    }

    deleteAccount = () => {
        new Company({ _id: this.state.accounttodelete._id })
            .deleteFromAPI()
            .then(() => {
                this.context.openSnackbar("Account deleted.", "success");
                this.closeModal();
                this.props.tabHostProxy.closeOther(this.state.accounttodelete._id, true);
                this.props.tabHostProxy.refresh();
            })
            .catch((error) => {
                this.context.openSnackbar(error, "error");
            });
    }

    openModal = (prompt, buttonText, fxn) => {
        this.setState({
            modal: {
                "open": true,
                prompt: prompt,
                yesFunction: fxn,
                functionText: buttonText,
            }
        });
    }

    closeModal = () => {
        let newState = { modal: { open: false } };
        this.setState(newState);
    }

    render_card_layout = () => {
        const { accounts, classes } = this.props;
        if (!accounts) {
            return <Loading />;
        }
        return (
            <React.Fragment>
                {accounts.map((account) => (
                    <div key={account._id} className={classes.integrationCardContainer}>
                        <SimpleModalWrapped info={this.state.modal} closeModal={this.closeModal} />
                        <Card className={classes.integrationCard}>
                            <div className={classes.optionsIconsContainer}>
                                <div className={classes.rightOptionsContainer}>
                                    {this.get_actions().map((action, index) => (
                                        <div onClick={() => { this.executeAction(action, account) }} key={action.label} className={classes.optionsIcon}>
                                            <Tooltip classes={{ tooltip: classes.tipOverride }} title={<span className={classes.tip}>{action.label + " this account"}</span>}>
                                                {action.icon}
                                            </Tooltip>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div onClick={() => { this.open_account_tab(account) }} className={classes.imageContainer}>
                                {this.render_account_logo(account)}
                            </div>
                            <div onClick={() => { this.open_account_tab(account) }} className={classes.textRowContainer}>
                                <div className={classes.title}>
                                    {account.name}
                                </div>
                                <div className={classes.iconWithTextContainer}>
                                    <Tooltip title="Website">
                                        <LanguageIcon className={classes.companyIcon} />
                                    </Tooltip>
                                    <div className={classes.iconLabel}>
                                        {account.website && account.website !== "" ? account.website : "No website set"}
                                    </div>
                                </div>
                                <div className={classes.iconWithTextContainer}>
                                    <Tooltip title="Parent Account">
                                        <AccountCircleIcon className={classes.companyIcon} />
                                    </Tooltip>
                                    <div className={classes.iconLabel}>
                                        {account.nested_company ? account.nested_company.name : "Company Parent Unknown"}
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                ))}
            </React.Fragment>
        );
    }

    render() {
        let { accounts, page_data, tabHostProxy, classes } = this.props;
        let buttons = Permissions.allow(["create"], "company") ? [{ label: "CREATE ACCOUNT", icon: (<AddIcon />), action: this.create_account }] : undefined;
        return (
            <div className={classes.container}>
                <PaginationContainer
                    count={page_data.total}
                    buttons={buttons}
                    rowsPerPage={page_data.per_page}
                    currentPage={page_data.page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    toggleView={(layout) => this.setState({ layout: layout })}
                    toggle_filter={this.props.show_filters}
                    filtering={this.props.filtering}
                />
                {this.state.layout === "card" ?
                    <div className={classes.cardItemsContainer}>
                        {this.render_card_layout()}
                    </div> :
                    <div className={classes.tableItemsContainer}>
                        {this.render_table_layout()}
                    </div>
                }
            </div>
        );
    }
}

AccountsList.contextType = SnackbarContext;
export default withStyles(styles)(AccountsList);

